import * as Dtos from '../dtos/Tmd.dtos';

export function hasPermission(personnelTmdPermissions: Dtos.PersonnelTmdPermissions[], permission: Dtos.Permission, trialId?: number | null, institutionId?: number | null): boolean {

    if (personnelTmdPermissions && personnelTmdPermissions.length > 0) {
        if (trialId !== undefined && institutionId !== undefined && trialId !== null && institutionId !== null) {
            if (personnelTmdPermissions.some(g => g.trialMatch && g.trialId == trialId && g.institutionMatch && g.institutionId == institutionId && g.permission == permission)) {
                return true;
            }
            //check for a higher permission on the trial
            if (personnelTmdPermissions.some(g => g.trialMatch && g.trialId == trialId && !g.institutionMatch && g.permission == permission)) {
                return true;
            }
        }
        if (trialId !== undefined && trialId !== null && (institutionId === undefined || institutionId === null)) {
            if (personnelTmdPermissions.some(g => g.trialMatch && g.trialId == trialId && g.permission == permission)) {
                return true;
            }
        }
        if ((trialId === undefined || trialId === null) && institutionId !== undefined && institutionId !== null) {
            if (personnelTmdPermissions.some(g => !g.trialMatch && g.institutionMatch && g.institutionId == institutionId && g.permission == permission)) {
                return true;
            }
        }
        if (personnelTmdPermissions.some(g => !g.trialMatch && !g.institutionMatch && g.permission == permission)) {
            return true;
        }
    }
    return false;
}

export function hasPermissionAnyMatch(personnelTmdPermissions: Dtos.PersonnelTmdPermissions[], permission: Dtos.Permission): boolean {

    if (personnelTmdPermissions && personnelTmdPermissions.length > 0) {
        if (personnelTmdPermissions.some(g => g.permission == permission)) {
            return true;
        }
    }
    return false;
}

export function hasAnyPermission(personnelTmdPermissions: Dtos.PersonnelTmdPermissions[], permissions: Dtos.Permission[]): boolean {
    if (personnelTmdPermissions.length == 0) {
        return false;
    }

    for (let i = 0; i < permissions.length; i++) {
        if (personnelTmdPermissions.some(f => f.permission == permissions[i])) {
            return true;
        }
    }

    return false;
}

export function hasCreateEditPermission(form: any, permissions: Dtos.PersonnelTmdPermissions[], editPermission: Dtos.Permission, createPermission: Dtos.Permission): boolean {
    
    let id: number | undefined;
    let trialId: number | undefined;
    let institutionId: number | undefined;

    if (form) {
        if (form.id != undefined && form.id != null && !isNaN(form.id) && form.id > 0) {
            id = form.id;
        }

        if (form.institutionId != undefined && form.institutionId != null && form.institutionId > 0) {
            institutionId = form.institutionId;
        }

        if (form.trialId != undefined && form.trialId != null && form.trialId > 0) {
            trialId = form.trialId;
        }
    }

    const isNew = (id !== undefined) ? false : true;
    const canCreate: boolean = hasPermission(permissions, createPermission, trialId, institutionId);
    const canEdit: boolean = hasPermission(permissions, editPermission, trialId, institutionId);
    const result: boolean = (isNew && canCreate) || (!isNew && canEdit);

    return result;
}

export function hasCreateEditPermissionFor(trialId: number | null | undefined, institutionId: number | null | undefined, permissions: Dtos.PersonnelTmdPermissions[], editPermission: Dtos.Permission, createPermission: Dtos.Permission): boolean {

    let _id: number | undefined;
    let _trialId: number | undefined;
    let _institutionId: number | undefined;

    if (trialId != undefined && trialId != null && !isNaN(trialId) && trialId > 0) {
        _id = trialId;
        _trialId = trialId;
    }

    if (institutionId != undefined && institutionId != null && !isNaN(institutionId)  && institutionId > 0) {
        _id = institutionId;
        _institutionId = institutionId;
    }

    const isNew = (_id !== undefined) ? false : true;
    const canCreate: boolean = hasPermission(permissions, createPermission, _trialId, _institutionId);
    const canEdit: boolean = hasPermission(permissions, editPermission, _trialId, _institutionId);
    const result: boolean = (isNew && canCreate) || (!isNew && canEdit);
    return result;
}

export function hasCreateEditPermissionForId(id: number, permissions: Dtos.PersonnelTmdPermissions[], editPermission: Dtos.Permission, createPermission: Dtos.Permission): boolean {

    let _id: number | undefined;
    if (id != undefined && id != null && !isNaN(id) && id > 0) {
        _id = id;
    }
    const isNew = (_id !== undefined) ? false : true;
    const canCreate: boolean = hasPermission(permissions, createPermission, undefined, undefined);
    const canEdit: boolean = hasPermission(permissions, editPermission, undefined, undefined);
    const result: boolean = (isNew && canCreate) || (!isNew && canEdit);

    return result;
}
